import { gql } from 'graphql-request';

export const GET_ADMIN_ISSUES = gql`
  query getAdminIssues($fleetId: Int!) {
    adminIssues(fleetId: $fleetId) {
      clientId
      portalAccountId
      fleetId
      clientLocation
      canAddBatteries
      canUpdateBatteries
      canIgnoreBatteries
      unexpectedBatteries {
        batteriesNotInSystem {
          serial
          manufacturer
          model
          powerLoggerSerial
          voltage
          capacity
          serviceEntryDate
          configuration {
            factory {
              bms_serial_number
              name
              asset_serial_number
              model_number
              manufacturer
              voltage
              capacity
              battery_type
              cable_configuration
              truck_name
              truck_type
              version
              minimum_compatible_schema
              seq_count
              duplicate_count
              release_level
              distribution_group
              charger_type
              idle_current_threshold
              truck_id_present
              sim_type
              target_server
              debug_data_enabled
              battery_sub_type
              charge_start_rate
              charge_profile
              service_entry_date
              bms_type
              bms_mac_address
            }
          }
        }
        batteriesThatExist {
          serial
          alias
          manufacturer
          model
          powerLoggerSerial
          voltage
          capacity
          serviceEntryDate
          currentAccountId
          currentAccountName
          canMove
        }
      }
      unlicensedBatteries {
        serial
        alias
        manufacturer
        model
        firmwareUpToDate
        powerLoggerSerial
        voltage
        capacity
        serviceEntryDate
        firmwareUpToDate
        licensed
      }
      firmwareIssueBatteries {
        serial
        alias
        manufacturer
        model
        firmwareUpToDate
        powerLoggerSerial
        voltage
        capacity
        serviceEntryDate
        firmwareUpToDate
        licensed
      }
      ignoredBatteries {
        serial
        alias
        manufacturer
        model
        firmwareUpToDate
        powerLoggerSerial
        voltage
        capacity
        serviceEntryDate
        firmwareUpToDate
        licensed
      }
      recentlyAddedBatteries {
        serial
        alias
        manufacturer
        model
        firmwareUpToDate
        powerLoggerSerial
        voltage
        capacity
        serviceEntryDate
        firmwareUpToDate
        licensed
      }
      totalLicenses
      availableLicenses
      availableLicenseSerials
    }
  }
`;
